import React, { useState } from 'react';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from 'reactstrap';

const isValidQty = (value) => {
  if (value === '' || value === null || value === undefined) return false;
  const n = parseFloat(value);
  if (isNaN(n) || n < 0) return false;
  return /^\d+(\.\d{1,2})?$/.test(String(value).trim());
};

const AttendanceAdjustModal = ({ isOpen, toggle, onSave, isSaving }) => {
  const [qty, setQty] = useState('');

  const handleClose = () => {
    setQty('');
    toggle();
  };

  const handleSave = () => {
    if (!isValidQty(qty)) {
      alert('Ingrese un valor numérico válido (máximo 2 decimales)');
      return;
    }
    onSave(parseFloat(qty));
    setQty('');
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose}>
      <ModalHeader toggle={handleClose}>Ingresar consolidado o ajuste</ModalHeader>
      <ModalBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleSave();
          }}
        >
          <FormGroup>
            <Label>Cantidad</Label>
            <Input
              type="number"
              min="0"
              step="0.01"
              value={qty}
              onChange={(e) => setQty(e.target.value)}
              placeholder="Ej: 1.50"
              autoFocus
            />
          </FormGroup>
          <Button color="success" size="sm" disabled={isSaving} onClick={handleSave}>
            {isSaving ? (
              <i className="nc-icon nc-refresh-69 fa-spin" />
            ) : (
              <>
                <i className="fa fa-floppy-o" aria-hidden="true"></i> Grabar
              </>
            )}
          </Button>{' '}
          <Button color="secondary" size="sm" disabled={isSaving} onClick={handleClose}>
            Cancelar
          </Button>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export { AttendanceAdjustModal };
